import React from "react";
import { useParams } from "react-router-dom";
import { getGameConfig } from "../games";
import { useGameplaySession } from "../hooks/useGameplaySession";
import { GameStatus } from "../types/gameplay";
import OrtografiaGame from "./OrtografiaGame";

const Ortografia = () => {
  const { date } = useParams();
  const gameConfig = getGameConfig("ortografia");

  const {
    puzzleConfig,
    state: sessionState,
    solutions,
    solutionsAvailable,
    status,
    won,
    justLost,
    justWon,
    isLoading,
    error: sessionError,
    isEventPending,
    dispatchEvent,
    dispatchHintEvent,
    hintAllowance,
    refreshHintAllowance,
    isSignedIn,
  } = useGameplaySession(gameConfig.id, date, {
    deriveStatusFromLocalStorage: (data) => {
      // For localStorage fallback only
      if (data?.playerWon) return GameStatus.WON;
      if (data?.score > 0 || (data?.submittedWords?.length > 0)) return GameStatus.IN_PROGRESS;
      return GameStatus.NOT_STARTED;
    },
  });

  return (
    <OrtografiaGame
      key={sessionState?.session_id || date}
      date={date}
      gameConfig={gameConfig}
      puzzleConfig={puzzleConfig}
      sessionState={sessionState}
      solutions={solutions}
      solutionsAvailable={solutionsAvailable}
      status={status}
      won={won}
      justLost={justLost}
      justWon={justWon}
      isLoading={isLoading}
      sessionError={sessionError}
      isEventPending={isEventPending}
      dispatchEvent={dispatchEvent}
      dispatchHintEvent={dispatchHintEvent}
      hintAllowance={hintAllowance}
      refreshHintAllowance={refreshHintAllowance}
      isSignedIn={isSignedIn}
    />
  );
};

export default Ortografia;
